'use client'

import { Navbar } from 'components/navbar'
import { Footer } from 'components/footer'
import { ProjectSalesList } from 'components/Projects/project-sales-list'
import { CarouselBanner } from 'components/carousel-banner'
import { useNavigate } from 'react-router-dom'
import useListV2 from 'hooks/useListV2'

export default function ProjectsPage() {
  const navigate = useNavigate()
  const { data: projects = [] } = useListV2()

  const projectNeedingTge = projects.find(
    (p) => p.status === 'Completed' && !p.tgeDate,
  )
  const shouldShowTgeBanner = !!projectNeedingTge

  return (
    <div className="flex flex-col min-h-screen bg-neutral-white font-sans text-slate-400">
      <Navbar />
      {shouldShowTgeBanner && projectNeedingTge && (
        <CarouselBanner
          type="Ending Soon"
          message={`Action required: TGE date is missing for ${projectNeedingTge.projectName}. Please set the token generation event (TGE) date to continue.`}
          buttonText="Set TGE Date"
          buttonAction={() => navigate(`/deals/${projectNeedingTge.id}`)}
        />
      )}
      <main className="flex-1 flex flex-col">
        <ProjectSalesList />
      </main>
      <Footer />
    </div>
  )
}
